export default "__VITE_ASSET__DePJn$C0__"